/* ============================================================
   تبديل اللغة
   اللغة تُحفظ وتُطبّق على كل صفحة، وإلا رجعت للإنجليزي
   عند فتح صفحة المنتج أو أي انتقال داخل الموقع.
   ============================================================ */
(function () {
  var KEY = 'arab-lang';

  function apply(lang) {
    var rtl = lang === 'ar';
    document.documentElement.lang = lang;
    document.documentElement.dir = rtl ? 'rtl' : 'ltr';

    document.querySelectorAll('[data-en]').forEach(function (el) {
      var v = el.getAttribute(rtl ? 'data-ar' : 'data-en');
      if (v != null && v !== '') el.innerHTML = v;
    });
    document.querySelectorAll('[data-ph-en]').forEach(function (el) {
      var v = el.getAttribute(rtl ? 'data-ph-ar' : 'data-ph-en');
      if (v != null) el.placeholder = v;
    });
    document.querySelectorAll('[data-label-en]').forEach(function (el) {
      var v = el.getAttribute(rtl ? 'data-label-ar' : 'data-label-en');
      if (v != null) el.setAttribute('aria-label', v);
    });
    document.querySelectorAll('.lang button').forEach(function (b) {
      b.setAttribute('aria-pressed', String(b.dataset.lang === lang));
    });

    try { localStorage.setItem(KEY, lang); } catch (e) {}
  }

  window.applyLang = apply;
  window.currentLang = function () {
    try { return localStorage.getItem(KEY) || 'en'; } catch (e) { return 'en'; }
  };

  /* التبديل: نطبّق الترجمة فوراً، ثم ننتقل لمسار شوبيفاي لنفس اللغة
     إن كان مختلفاً، عشان صفحة الدفع والحساب تتبع اللغة كذلك. */
  document.querySelectorAll('.lang button').forEach(function (b) {
    b.addEventListener('click', function () {
      var lang = b.dataset.lang;
      apply(lang);
      var A = window.ARAB || {};
      if (A.shopifyLocale && A.localeRoots && A.shopifyLocale !== lang && A.localeRoots[lang] != null) {
        var root = A.localeRoots[lang] || '/';
        var path = location.pathname;
        var current = A.localeRoots[A.shopifyLocale] || '/';
        if (current !== '/' && path.indexOf(current) === 0) path = path.slice(current.length) || '/';
        var target = (root === '/' ? '' : root) + (path.charAt(0) === '/' ? path : '/' + path);
        location.href = target + location.search + location.hash;
      }
    });
  });

  /* لغة شوبيفاي هي المرجع لو كان الزبون على مسار /ar،
     وإلا نستخدم المحفوظة. هذا يمنع تعارض المبدّل مع الدفع. */
  (function () {
    var A = window.ARAB || {};
    var saved = window.currentLang();
    var start = (A.shopifyLocale === 'ar' || A.shopifyLocale === 'en') ? A.shopifyLocale : saved;
    apply(start);
  })();

  /* أي محتوى يُضاف لاحقاً (السلة، تبديل الحجم) يُترجم تلقائياً */
  try {
    var mo = new MutationObserver(function (records) {
      var needs = false;
      records.forEach(function (r) {
        Array.prototype.forEach.call(r.addedNodes, function (n) {
          if (n.nodeType !== 1) return;
          if (n.hasAttribute('data-en') || n.querySelector('[data-en]')) needs = true;
        });
      });
      if (needs) apply(window.currentLang());
    });
    mo.observe(document.body, { childList: true, subtree: true });
  } catch (e) {}
})();

window.wireReveal = function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    document.querySelectorAll('.reveal').forEach(function (el) { el.classList.add('in'); });
    return;
  }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e, i) {
      if (e.isIntersecting) {
        e.target.style.transitionDelay = Math.min(i, 4) * 40 + 'ms';
        e.target.classList.add('in');
        io.unobserve(e.target);
      }
    });
  }, { rootMargin: '0px 0px -8% 0px' });
  document.querySelectorAll('.reveal:not(.in)').forEach(function (el) { io.observe(el); });
};
window.wireReveal();
